import type { TRecommendationsElement } from '@shared/dream-components';
import { RecommendationsElement } from '@shared/dream-components';
import type { ReactNode } from 'react';
import { ClientOnly } from 'remix-utils/client-only';

import RecommendationsAction from '~/components/RecommendationsAction';

interface Props {
  node: TRecommendationsElement;
  children: ReactNode | ReactNode[];
}

const Recommendations = ({ node, children }: Props) => {
  return (
    <ClientOnly fallback={null}>
      {() => (
        <RecommendationsAction node={node}>
          {({
            email,
            recommendations,
            handleChangeInRecommendations,
            handleSelectAllRecommendations,
            handleDeselectAllRecommendations,
            onClickSubmit,
            onClickCancel,
          }) => {
            return (
              <RecommendationsElement
                element={node}
                onChange={handleChangeInRecommendations}
                email={email}
                showForm={recommendations.length > 0}
                selectedRecommendations={recommendations}
                portalElement={typeof window !== 'undefined' ? window?.document?.body : undefined}
                onClickSubmit={onClickSubmit}
                onClickCancel={onClickCancel}
                onSelectAll={handleSelectAllRecommendations}
                onDeselectAll={handleDeselectAllRecommendations}
                isLive
              >
                {children}
              </RecommendationsElement>
            );
          }}
        </RecommendationsAction>
      )}
    </ClientOnly>
  );
};

export default Recommendations;
